import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const InfoItem = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.$inline ? 'row' : 'column')};
  gap: ${(props) => (props.$inline ? '4px' : '4px')};
  margin-bottom: ${(props) => (props.$inline ? '0' : '8px')};
  align-items: ${(props) => (props.$inline ? 'center' : 'flex-start')};
`;

export const InfoLabel = styled.span<{ $inline?: boolean }>`
  font-size: ${(props) => (props.$inline ? '10px' : '12px')};
  color: #8c8c8c !important;
  font-weight: 400;
  white-space: nowrap;
`;

export const StyledText = styled(Text)<{ $inline?: boolean }>`
  font-size: ${(props) =>
    props.$inline ? '10px !important' : '14px !important'};
  color: ${(props) =>
    props.$inline ? '#000 !important' : '#262626 !important'};
  font-weight: ${(props) =>
    props.$inline ? '400 !important' : '500 !important'};

  .anticon-copy,
  .anticon-check {
    color: #f78e1e !important;
    font-size: ${(props) =>
      props.$inline ? '10px !important' : '14px !important'};
    border: 1px solid #f78e1e;
    padding: 2px;
  }

  .ant-typography-copy {
    color: #f78e1e !important;
  }

  .ant-typography-copy:hover {
    color: #e67e22 !important;
  }
`;
